import { createRouter } from '@tanstack/react-router'
import { routeTree } from './routeTree.gen'
import type { QueryClient } from '@tanstack/react-query'
import type { AxiosInstance } from 'axios'

export const router = createRouter({
    routeTree, context: {
        auth: undefined!,
        queryClient: undefined!,
        api: undefined! as AxiosInstance,
    },
})

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router
    }
}

export type RouterContext = {
    auth: import('@auth0/auth0-react').Auth0ContextInterface
    queryClient: QueryClient
    api: AxiosInstance
}

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router
    }
}
